export const headers = [
  {
    text: "",
    value: "actions",
    sortable: false,
  },
  {
    text: "Reference Sequence",
    value: "refSeq",
    sortable: false,
  },
  {
    text: "New Hire Steps",
    value: "newHireSteps",
    sortable: false,
  },
  {
    text: "Step Sequence",
    value: "stepSequence",
    sortable: false,
  },
  {
    text: "Sub Step Sequence",
    value: "subStepSequence",
    sortable: false,
  },
  {
    text: "Day Schedule",
    value: "daySched",
    sortable: false,
  },
  {
    text: "In Charge",
    value: "inCharge",
    sortable: false,
  },
  {
    text: "When",
    value: "when",
    sortable: false,
  },
  {
    text: "Checklist form link",
    value: "checklistForm",
    sortable: false,
  },
  {
    text: "Deadline Reminder",
    value: "reminder",
    sortable: false,
  },
];
